import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-amber-500/20 py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/phos-logo.webp" alt="PHOS Studio" className="w-10 h-10 object-contain" />
              <span className="text-2xl font-black text-white">PHOS STUDIO</span>
            </Link>
            <p className="text-slate-400 leading-relaxed">
              Creating content that gets seen.
            </p>
          </div>
          <div>
            <h3 className="text-white font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/social-media-service" className="text-slate-400 hover:text-amber-400 transition-colors">Social Media & Ads</Link></li>
              <li><Link to="/editing" className="text-slate-400 hover:text-amber-400 transition-colors">Video Editing</Link></li>
              <li><Link to="/ugc-production" className="text-slate-400 hover:text-amber-400 transition-colors">UGC Production</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-bold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/portfolio" className="text-slate-400 hover:text-amber-400 transition-colors">Portfolio</Link></li>
              <li><Link to="/editing" className="text-slate-400 hover:text-amber-400 transition-colors">Services</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-amber-400 transition-colors">Contact</Link></li>
              <li><Link to="/newsletter" className="text-slate-400 hover:text-amber-400 transition-colors">Newsletter</Link></li>
              <li><Link to="/privacy" className="text-slate-400 hover:text-amber-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-slate-400 hover:text-amber-400 transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-bold mb-4">Connect</h3>
            <a href="mailto:contact@phosstudio.net" className="flex items-center gap-2 text-slate-400 hover:text-amber-400 transition-colors mb-4">
              <Mail className="w-4 h-4" />
              <span>contact@phosstudio.net</span>
            </a>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/phos.creatives/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a href="https://www.facebook.com/PHOSStudios/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-400">© 2024 PHOS Studio. All rights reserved. Built for brands that refuse to blend in.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;